import { render, staticRenderFns } from "./KhatmaResult.vue?vue&type=template&id=29caa73c&scoped=true&"
import script from "./KhatmaResult.vue?vue&type=script&lang=js&"
export * from "./KhatmaResult.vue?vue&type=script&lang=js&"
import style0 from "./KhatmaResult.vue?vue&type=style&index=0&id=29caa73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29caa73c",
  null
  
)

export default component.exports